import React from "react";
import AcquireWebComponent from "../../framework/MaterialUI";

import {
  BarChart,
  Bar,
  Cell,
  XAxis,
  YAxis,
  CartesianGrid,
  ResponsiveContainer,
  Tooltip,
} from "recharts";
import map from "lodash/map";
import reduce from "lodash/reduce";
import maxBy from "lodash/maxBy";
import isEmpty from "lodash/isEmpty";

const CustomTooltip = ({ active, payload, label }) => {
  if (active) {
    return (
      <div
        className="recharts-default-tootip no-margin pt-10 pl-20 pr-20 pb-15"
        style={{ background: "#000", border: "solid 1px #000", color: "#FFF" }}
      >
        <p className="recharts-tooltip-label no-margin" />
        <ul className="recharts-tooltip-item-list no-padding no-margin">
          <li
            className="recharts-tooltip-item"
            style={{
              display: "inline",
              paddingTop: "4px",
              paddingBottom: "4px",
              width: "100%",
            }}
          >
            <div
              style={{
                width: "auto",
                height: "25px",
                display: "block",
                overflow: "overlap",
                whiteSpace: "nowrap",
                textOverflow: "unset",
              }}
            >
              {isEmpty(payload) ? (
                ""
              ) : (
                <div className="recharts-tooltip-label no-margin-left no-margin-top no-margin-right mb-5">
                  {payload[0].payload.key +
                    " : " +
                    payload[0].payload.percentage.toLocaleString(undefined, {
                      style: "percent",
                      minimumFractionDigits: 2,
                    }) +
                    "%"}
                </div>
              )}
            </div>
          </li>
        </ul>
      </div>
    );
  }

  return null;
};
class VerticalBarChart extends AcquireWebComponent {
  formatXAxis(item) {
    return item === 0 ? item : parseInt(item, 10) + "%";
  }

  isEmpty(data) {
    if (!data || data.length === 0) return true;
    for (var i = 0; i < data.length; i++) {
      if (data[i].value > 0) return false;
    }
    return true;
  }

  render() {
    const { title, data } = this.props;
    const processData = [];
    const sum = reduce(
      data,
      function(sum, d) {
        return sum + d.value;
      },
      0,
    );

    map(data, d => {
      if (d.key !== "Unknown")
        processData.push({
          key: d.key,
          value: d.value,
          percentage: ((d.value / sum) * 100).toFixed(2),
        });
    });
    const maxData = maxBy(processData, d => {
      return parseInt(d.percentage, 10);
    });
    const maxVal = maxData ? parseInt(maxData.percentage) : 0;
    if (this.isEmpty(processData)) {
      return (
        <div>
          <div
            style={{
              fontSize: "24px",
              fontWeight: "bold",
              padding: "20px",
            }}
          >
            {title}
          </div>

          <div
            style={{
              width: "100%",
              minHeight: "200px",
              textAlign: "center",
              paddingTop: "60px",
              color: "#CDCDCD",
            }}
          >
            <div style={{ color: "#CDCDCD", fontSize: "28pt", opacity: "0.8" }}>
              No Data
            </div>
          </div>
        </div>
      );
    }
    return (
      <div>
        <div
          style={{
            fontSize: "24px",
            fontWeight: "bold",
            padding: "20px",
          }}
        >
          {title}
        </div>
        <ResponsiveContainer
          width="100%"
          height="100%"
          minWidth="400px"
          minHeight={this.props.height}
        >
          <BarChart
            data={processData}
            layout="vertical"
            margin={this.props.chartMargin}
            maxBarSize={20}
          >
            <CartesianGrid strokeDasharray="3 3" horizontal={false} />
            <XAxis
              type="number"
              domain={[0, maxVal > 95 ? 100 : maxVal + 3]}
              tickCount={5}
              tickFormatter={this.formatXAxis}
            />
            <YAxis
              dataKey="key"
              type="category"
              width={this.props.yAxisWidth}
              padding={{top: 20}}
              mirror={!!this.props.yMirror}
              tickLine={!this.props.yTickHide}
            />
            <Bar dataKey="percentage" fill="#216E69" />
            <Tooltip content={<CustomTooltip />} cursor={false} />
          </BarChart>
        </ResponsiveContainer>
        {this.props.children}
      </div>
    );
  }
}

VerticalBarChart.defaultProps = {
  chartMargin: {
    top: 0,
    right: 20,
    left: 10,
    bottom: 20,
  },
  yAxisWidth: 60,
  height: "300px",
};
export default VerticalBarChart;



// WEBPACK FOOTER //
// ./src/components/Insights/distribution/VerticalBarChart.js